export default __webpack_public_path__ + "static/media/chairman.15c124f6.png";